import { useEffect, useRef } from 'react';
import { Logo3D } from './Logo3D.js';
import { useSettings } from '../settings/SettingsContext.js';
import { logoDef } from '../lib/logos.js';

// Apple-style launch sequence, shown once right after sign-in. The mark focuses in with a spring
// (blur to sharp, scale settle) over an ambient bloom tinted to the user's logo colourway; the
// wordmark rises as a specular sheen sweeps across it; a hairline fills; then the whole scene
// launch-zooms and fades into the app. Pure CSS timeline — calls onDone when it finishes (also on
// click/tap to skip). Honors prefers-reduced-motion (fade only, no springs/zoom/sheen).
export function BootAnimation({ onDone }: { onDone: () => void }) {
  const { prefs } = useSettings();
  const glow = logoDef(prefs.logo).glow; // bloom + logo shadow follow the chosen colourway

  // schedule once: AppShell passes a fresh onDone every render, which would keep restarting the timer.
  // Escape is the keyboard twin of click-to-skip.
  const doneRef = useRef(onDone);
  doneRef.current = onDone;
  useEffect(() => {
    const t = setTimeout(() => doneRef.current(), 2200);
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') doneRef.current(); };
    window.addEventListener('keydown', onKey);
    return () => { clearTimeout(t); window.removeEventListener('keydown', onKey); };
  }, []);

  return (
    <div
      className="boot"
      role="presentation"
      onClick={onDone}
      style={{ ['--boot-glow']: glow } as React.CSSProperties}
    >
      <div className="boot-core">
        <span className="boot-mark">
          <Logo3D size={148} layers={16} depth={1.5} speed={2.8} />
        </span>
        <div className="boot-title" data-text="ROLODEX">ROLODEX</div>
        <div className="boot-sub">Technohull · Assembly</div>
        <div className="boot-bar"><span /></div>
      </div>
    </div>
  );
}
